export const countries = [
    { code: '+90', country: 'TR', name: 'Türkiye', flag: '🇹🇷' },
    { code: '+1', country: 'US', name: 'Amerika', flag: '🇺🇸' },
    { code: '+44', country: 'GB', name: 'İngiltere', flag: '🇬🇧' },
    { code: '+49', country: 'DE', name: 'Almanya', flag: '🇩🇪' },
    { code: '+33', country: 'FR', name: 'Fransa', flag: '🇫🇷' },
    { code: '+39', country: 'IT', name: 'İtalya', flag: '🇮🇹' },
    { code: '+34', country: 'ES', name: 'İspanya', flag: '🇪🇸' },
    { code: '+31', country: 'NL', name: 'Hollanda', flag: '🇳🇱' },
    { code: '+41', country: 'CH', name: 'İsviçre', flag: '🇨🇭' },
    { code: '+43', country: 'AT', name: 'Avusturya', flag: '🇦🇹' },
    { code: '+46', country: 'SE', name: 'İsveç', flag: '🇸🇪' },
    { code: '+47', country: 'NO', name: 'Norveç', flag: '🇳🇴' },
    { code: '+45', country: 'DK', name: 'Danimarka', flag: '🇩🇰' },
    { code: '+358', country: 'FI', name: 'Finlandiya', flag: '🇫🇮' },
    { code: '+7', country: 'RU', name: 'Rusya', flag: '🇷🇺' },
    { code: '+86', country: 'CN', name: 'Çin', flag: '🇨🇳' },
    { code: '+81', country: 'JP', name: 'Japonya', flag: '🇯🇵' },
    { code: '+82', country: 'KR', name: 'Güney Kore', flag: '🇰🇷' },
    { code: '+91', country: 'IN', name: 'Hindistan', flag: '🇮🇳' },
    { code: '+55', country: 'BR', name: 'Brezilya', flag: '🇧🇷' },
    { code: '+61', country: 'AU', name: 'Avustralya', flag: '🇦🇺' },
    { code: '+971', country: 'AE', name: 'BAE', flag: '🇦🇪' },
    { code: '+966', country: 'SA', name: 'Suudi Arabistan', flag: '🇸🇦' },
    { code: '+357', country: 'CY', name: 'Kıbrıs', flag: '🇨🇾' }
];